import '../services.css'; 

const QualityAssurance = () => {
  return (
    <div className="cover w-100">
      {/* Hero Section */}
      <div className="service-hero-section text-white py-5 text-center bg-primary">
        <h1 className="display-4 fw-bold mb-3">Quality Assurance</h1>

      </div>

      {/* Web Development Section */}
      <div className="container py-5">
        <div className="row align-items-center">
          {/* Left - Text */}
          <div className="col-md-8 mb-4 mb-md-0">
            <p className="text-justify">
              QA Testing is another name for Quality Assurance. Quality assurance (QA) is described as an activity that ensures an organisation provides the best product or service to its consumers.
            </p>
            <p className="text-justify">
              It appears that software quality assurance is all about evaluating software based on functionality, performance, and adaptability, nevertheless, software quality assurance encompasses the quality of the process used to design, test, and distribute the software.
            </p>
            <p className="text-justify">
              The Software Development lifecycle encompasses requirements management, software design, coding, testing, and release management, etc.
            </p> 
          </div>

          {/* Right - Image */}
          <div className="image-area col-md-4 text-center text-md-end h-100">
            <img
              src="assets\images\service\qualityAssurance.jpg"
              alt="Quality Assurance"
              className="img-fluid rounded shadow"
              style={{ width: '100%', height:'auto', objectFit: 'contain' }}
            />
          </div>
        </div>
      </div>

      {/* Additional Sections */}
      <div className="container py-2  ">
        {/* Unique Web Design */}
        <div className="mb-5">
          <h3 className="h4 fw-semibold mb-3">FUNCTIONAL TESTING</h3>
          <p className="text-justify">
            Functional testing is a critical component in improving the quality of generated software. Consumers' constantly-changing expectations and needs, the hazards of introducing a new product without rigorous quality assurance are larger now than ever before.
          </p>
        </div>

        {/* Responsive Web Design */}
        <div className="mb-5">
          <h3 className="h4 fw-semibold mb-3">AUTOMATION TESTING</h3>
          <p className="text-justify">
            Test automation remains a thriving term amongst QA teams in an effort to achieve faster time to market, expand test coverage, and improve test team efficiency. Automation testing necessitates dedicated work and a controlled setting. Lack of trained test automation engineers, test maintenance efforts, particularly in an agile product life cycle, ballooning test environment expenses, complex test data, and insufficient end-to-end test coverage are some of the primary obstacles that a test automation endeavour frequently encounters.Some frameworks we have expertise in are Selenium, Cucumber, Cypress, Puppeteer, Protractor,Ranorex, TestCafe.
          </p>
        </div>

        {/* Landing Page Design */}
        <div className="mb-5">
          <h3 className="h4 fw-semibold mb-3">MOBILE TESTING</h3>
          <p className="text-justify">
            To compete effectively in a changing global market, product firms release their apps on numerous platforms and devices, including iOS, Android, Windows, Mac, open source operating systems, and several mobile computing devices such as phones and e-readers. As a testing organisation, we have carved out a niche in mobile testing services, specifically testing applications on Android and iOS devices. Frameworks such as Appium and BrowserStack are something we are highly skilled in.
          </p>
        </div>

        {/* Performance Testing */}
        <div className="mb-4">
          <h3 className="h4 fw-semibold mb-3">PERFORMANCE TESTING</h3>
          <p className="text-justify">
           One of the most difficult difficulties enterprises face today is obtaining and sustaining peak performance and scalability levels for their mission essential applications. They are vulnerable to the types of catastrophic slowdowns and breakdowns that cripple production, drive away customers, and demolish the company's bottom line if they do not have an effective approach for anticipating system behaviour and performance under real-world stress conditions. JMeter and POSTMAN are some of the frameworks we have expertise in.
          </p>
        </div>


        {/* ACCESSIBILITY TESTING */}
        <div className="mb-4">
          <h3 className="h4 fw-semibold mb-3">ACCESSIBILITY TESTING</h3>
          <p className="text-justify">
           As important as cognitive accessibility is, Panorama focuses on providing the correct combination of manual and automated test approaches, with end user inclusivity as the key. We have a strong interest in automated accessibility, and with the combined expertise of our automation and accessibility teams, we have been able to leverage the latest in the industry, such as image recognition, natural language processing, and machine learning APIs, to bring AI powered automation to this space.
          </p>
        </div>

        {/* USABILITY TESTING */}
        <div className="mb-4">
          <h3 className="h4 fw-semibold mb-3">USABILITY TESTING</h3>
          <p className="text-justify">
           Usability is a critical factor in determining a product's market adoption. Along with the web, a successful mobile user experience is more crucial than ever, and Panorama has developed a mobile usability testing methodology based on our experience with a diverse range of clients. We have also teamed with domain experts in specific scenarios to test for usability in depth in order to deliver a full range of software testing services.
          </p>
        </div>

        {/* SECURITY TESTING */}
        <div className="mb-4">
          <h3 className="h4 fw-semibold mb-3">SECURITY TESTING</h3>
          <p className="text-justify">
           In today's environment of rapid digital change, cyber security has emerged as a critical business factor in a product's consumer acceptance and operational legitimacy. The scale and scope of security engineering are expanding by the day, necessitating engineering teams to adapt to novel tactics for mitigating threats and working with a combination of tools and automated solutions to look beyond standard web application security issues.
          </p>
        </div>

      </div>
    </div>
  );
};

export default QualityAssurance;
